document.addEventListener("DOMContentLoaded", function () {

  const CART_URL = "/cart"; // URL fixe du panier

  function showSuccessBar() {
    if (document.getElementById("wl-success-bar")) return;

    const bar = document.createElement("div");
    bar.id = "wl-success-bar";
    bar.innerHTML = `
      <span class="wl-text">
        ${
          document.documentElement.lang === "en"
            ? "Product added successfully"
            : document.documentElement.lang === "ar"
            ? "تم إضافة المنتج بنجاح"
            : "Produit ajouté avec succès"
        }
      </span>
      <button class="wl-close">&times;</button>
    `;
    document.body.appendChild(bar);

    bar.querySelector(".wl-close").addEventListener("click", () => {
      bar.classList.remove("show");
      setTimeout(() => bar.remove(), 300);
    });

    setTimeout(() => {
      if (document.getElementById("wl-success-bar")) {
        bar.classList.remove("show");
        setTimeout(() => bar.remove(), 300);
      }
    }, 5000);

    setTimeout(() => bar.classList.add("show"), 50);
  }

  function setupATC(button) {
    if (!button || button.dataset.listenerAdded === "true") return;

    const form = button.closest("form");
    if (!form) return;

    button.dataset.listenerAdded = "true";

    button.addEventListener("click", async function (e) {
      e.preventDefault();

      // Si déjà ajouté → redirection au panier
      if (button.dataset.added === "true") {
        window.location.href = CART_URL;
        return;
      }

      const formData = new FormData(form);

      try {
        await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: { "Accept": "application/json" }
        });

        const cartCountElem = document.querySelector(".header__cart-count-number");
        if (cartCountElem) {
          const cart = await fetch("/cart.js").then(r => r.json());
          cartCountElem.textContent = cart.item_count;
        }

        const lang = document.documentElement.lang;
        let txt = lang === "en" ? "View Cart" : lang === "ar" ? "عرض السلة" : "Voir Panier";
        button.textContent = txt;
        button.dataset.added = "true";

        button.classList.add("added-to-cart");
        setTimeout(() => button.classList.remove("added-to-cart"), 800);

        showSuccessBar();

      } catch (err) {
        console.error("Erreur ATC:", err);
      }
    });
  }

  const observer = setInterval(() => {
    document.querySelectorAll(".add-to-cart-sticky button, .quick-add__footer button").forEach(setupATC);
  }, 300);

  setTimeout(() => clearInterval(observer), 10000);

});

document.addEventListener("change", function (e) {
  if (e.target.name === "id") {
    const button = document.querySelector(".add-to-cart-sticky button");
    if (button) {
      button.dataset.added = "false";
      const lang = document.documentElement.lang;
      let txt = lang === "en" ? "Add to cart" : lang === "ar" ? "أضف إلى السلة" : "Ajouter au panier";
      button.textContent = txt;
    }
  }
});